export {default as getNameFromEmail} from "./getNameFromEmail";
export {default as getProfileChanges} from "./getProfileChanges";
export {default as updateProfile} from "./updateProfile";
